export default {
  governmentIssued: {
    en: "Government-issued",
    ja: "政府発行"
  },
  originalFullSize: {
    en: "Original full-size, unedited documents",
    ja: "元のフルサイズの未編集のドキュメント"
  },
  background: {
    en: "Place documents against a singe-coloured background",
    ja: "単色の背景に対してドキュメントを配置する"
  },
  readable: {
    en: "Readable, well-lit, colour images",
    ja: "読みやすく明るいカラー画像"
  },
  noBlackAndWhite: {
    en: "No black and white images",
    ja: "白黒画像はありません"
  },
  noEdited: {
    en: "No edited or expired documents",
    ja: "編集済みまたは期限切れのドキュメントはありません"
  }
}
